export const productCardTemplatePLP = `
<a
  href=""
  class="snize-view-link"
  data-no-instant="true"
  draggable="false"
  ><div class="snize-item clearfix">
    <div class="snize-thumbnail-wrapper">
      <div class="snize-product-label-image top-left"><img src=""></div>
      <span class="snize-thumbnail"
        ><img
          src=""
          class="snize-item-image"
          alt=""
          border="0"
          loading="lazy"
      /></span>
    </div>
    <span class="snize-overhidden"
      ><span
        class="snize-title"
        style="max-height: 4.2em; -webkit-line-clamp: 3"
        ></span
      ><span class="snize-sku"></span
      ><span class="snize-attribute">
        </span
      ><span
        class="snize-description"
        style="max-height: 5.6em; -webkit-line-clamp: 4"
        ></span
      >
      <div class="snize-price-list">
        <span class="snize-price snize-price-with-discount money " data-old-price="" data-formated="false">
        </span>
        <span class="snize-discounted-price money ">
        </span>
        <span class="snize-save-price-wrapper">
        </span>
        <span class="price-tax">
          IGIC Incl.
        </span>
      </div>
      <div
        data-bv-show="rating_summary"
        data-bv-product-id=""
        data-bv-ready="true"
      ></div
    ></span></div
></a>`;
